import styled from 'styled-components/macro';

export const CenteredContainer = styled.div`
  height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
